const getNamesFromList = (list) => {
  return list?.map((x) => x.name);
};

const getIdByName = (groupName, groupList) => {
  if (!groupName) return;
  return groupList?.find((group) => group.name === groupName)?.id;
};

const exportGroupReportingCompanies = (groupReportingCompanies, workbook) => {
  const sheet = workbook?.addWorksheet("Group Reporting Companies");
  const headerRow = sheet.addRow([
    "Group Name",
    "Supervisor Emails",
    "Reporting Company",
    "Nomination Link",
  ]);

  headerRow.eachCell((cell) => {
    cell.alignment = {
      wrapText: true,
      vertical: "middle",
      horizontal: "center",
    };
    cell.font = { bold: true };
  });

  sheet.autoFilter = {
    from: "A1",
    to: "D1",
  };

  for (let group of groupReportingCompanies) {
    const groupName = group.name;
    const supervisorEmails = group.supervisors?.length ? group.supervisors.join(", ") : "N/A";
    const companies = group.reportingCompanies || [];

    if (companies.length === 0) {
      sheet.addRow([groupName, supervisorEmails, "N/A", "N/A"]);
    } else {
      companies.forEach((company, index) => {
        sheet.addRow([
          index === 0 ? groupName : "",
          index === 0 ? supervisorEmails : "",
          company.name || "N/A",
          company.nominationLink || "N/A",
        ]);
      });
    }
  }

  sheet.getColumn(1).width = 40;
  sheet.getColumn(2).width = 35;
  sheet.getColumn(3).width = 35;
  sheet.getColumn(4).width = 50;

  return workbook;
};

export { exportGroupReportingCompanies, getIdByName, getNamesFromList };

